import { CHECK_VO_SOS_DATA } from './checkVoSosData';
import { HAS_ACCESS_TO_COBALT_REPORT } from './hasAccessToCobaltReport';
import { GET_SECRETARY_OF_STATE_REPORT } from './secretaryOfStateSearchReport';
import { PULL_SECRETARY_OF_STATE_SEARCH_REPORT } from './pullSecretaryOfStateSearchReport';
import { GET_LAST_SECRETARY_OF_STATE_REPORT_FOR_ACCOUNT } from './getLastSecretaryOfStateReportForAccount';

export const cobaltIntelligenceApi = {
  checkVoSosData: CHECK_VO_SOS_DATA,
  hasAccessToCobaltReport: HAS_ACCESS_TO_COBALT_REPORT,
  getSecretaryOfStateReport: GET_SECRETARY_OF_STATE_REPORT,
  pullSecretaryOfStateSearchReport: PULL_SECRETARY_OF_STATE_SEARCH_REPORT,
  getLastSecretaryOfStateReportForAccount: GET_LAST_SECRETARY_OF_STATE_REPORT_FOR_ACCOUNT,
};

export * from './types';
export * from './fragments/secretaryOfStateReportFragment';
